export default __webpack_public_path__ + "static/media/SLbg.52bf1186.png";